// Define the handleResponse function here instead of importing it
export async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage =
      errorData.message || `Error ${response.status}: ${response.statusText}`;
    throw new Error(errorMessage);
  }
  return (await response.json()) as T;
}
